import { render, staticRenderFns } from "./AddStBaseApplicant.vue?vue&type=template&id=3599d0df&"
import script from "./AddStBaseApplicant.vue?vue&type=script&lang=js&"
export * from "./AddStBaseApplicant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports